import { HTMLWidget, ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"
import { TitleIcon } from "~/loaders/TitleIcon"
import { clsx } from "~/sdk/clx"

interface Banner {
    /**
     * @title Texto alternativo
     */
    alt: string
    /**
     * @title Imagem
     */
    src: ImageWidget
}

interface Blog {
    /**
     * @title Título
     */
    title: HTMLWidget
    /**
     * @title Conteúdo
     */
    body: HTMLWidget
}

export interface Props {
    /**
     * @title Banner
     */
    banner?: Banner
    /**
     * @title Textos da seção
     */
    blog: Blog
    /**
     * @title Ícone
     */
    icon: TitleIcon
}

const BlogText = ({ banner, blog, icon }: Props) => {
    const { body, title } = blog

    if (body === undefined && banner === undefined && title === undefined) return null

    return (
        <div
            className={clsx(
                'flex flex-col gap-8 max-w-[1730px] mx-auto px-4 py-6 lg:py-12 w-full',
                'lg:flex-row lg:items-center lg:justify-between',
            )}
        >
            {banner !== undefined && (
                <Image
                    alt={banner.alt}
                    className={clsx(
                        'h-auto max-w-[40.875rem] object-cover overflow-hidden rounded-xl w-full mx-auto',
                        'xl:flex-shrink-0 xl:h-[26.4375rem] xl:max-w-[40.875rem] lg:mx-0',
                    )}
                    height={630}
                    src={banner.src}
                    width={980}
                    loading='lazy'
                />
            )}

            <div
                className={clsx(
                    'flex flex-col gap-8 max-w-[51.875rem] w-full mx-auto',
                    'lg:gap-6 lg:max-w-[51.075rem] lg:mx-0',
                )}
            >
                {title !== undefined && (
                    <div className='flex items-center gap-4 mx-auto'>
                        <Image
                            src={icon.icon}
                            alt={icon.alt}
                            width={icon.width}
                            height={icon.height}
                            loading='lazy'
                        />
                        <div
                            className={clsx(
                                'font-light leading-normal text-[#E5554F] text-center text-lg uppercase',
                                '[&_strong]:font-black [&_strong]:text-black',
                                'lg:text-4xl',
                            )}
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                        <Image
                            src={icon.icon}
                            alt={icon.alt}
                            width={icon.width}
                            height={icon.height}
                            loading='lazy'
                        />
                    </div>
                )}

                {body !== undefined && (
                    <div
                        className={clsx(
                            '[&_p]:font-normal [&_p]:leading-[1.5625rem] [&_p]:text-[#5A5A5A] [&_p]:text-sm [&_a]:hidden',
                            '[&_a]:font-bold [&_a]:leading-normal [&_a]:pt-4 [&_a]:text-pink [&_a]:text-base [&_a]:uppercase',
                            '[&_span]:flex',
                            '[&_strong]:font-bold',
                            'text-justify',
                            'lg:columns-2 lg:gap-[0_1rem] [&_a]:lg:flex',
                        )}
                        dangerouslySetInnerHTML={{ __html: body }}
                    />
                )}
            </div>
        </div>
    )
}

export default BlogText
